import {
    isValidElement,
    cloneElement,
    type FC
} from "react";
import type IPopoverCloseProps from "./type";
import type {
    PopoverCloseChildPropsType
} from "./type";
import {
    getPopoverCloseRadius,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    usePointerType
} from "../../../../helpers/pointer";
import {
    usePopoverContext
} from "../../context";
import {
    X as XIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";
import Button from "../../../button";

const PopoverCloseIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => <AnimatedIcon
    customColor={customColor}
    animationTrigger="hover"
    animation="signature"
    color={color}
    icon={XIcon}
    size={size}
/>;

const PopoverClose: FC<IPopoverCloseProps> = ({
    customLocalize: customLocalizeProp,
    customTheme: customThemeProp,
    children,
    style
}) => {
    const context = usePopoverContext({
        part: "Close"
    });

    const customLocalize = customLocalizeProp ?? context?.customLocalize;

    const customTheme = customThemeProp ?? context?.customTheme;

    const {
        controlHeights,
        touchTargets,
        typography,
        iconSizes,
        radiuses,
        borders,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const pointerType = usePointerType();

    const {
        close: closeDynamicStyle
    } = useStyles({
        controlHeights,
        touchTargets,
        pointerType,
        typography,
        iconSizes
    });

    if(!context) {
        return null;
    }

    const {
        handleClose
    } = context;

    if(isValidElement<PopoverCloseChildPropsType>(children)) {
        const handleChildPress = () => {
            children.props.onPress?.();

            handleClose();
        };

        return cloneElement(children, {
            onPress: handleChildPress,
            style: [
                children.props.style,
                style
            ]
        });
    }

    return <Button
        accessibilityLabel={localize("close")}
        borderRadius={getPopoverCloseRadius({
            controlHeights,
            typography,
            radiuses,
            borders,
            spaces
        })}
        customTheme={customTheme}
        icon={PopoverCloseIcon}
        style={[
            closeDynamicStyle,
            style
        ]}
        spreadBehaviour="free"
        onPress={handleClose}
        variant="ghost"
        type="neutral"
        size="small"
    />;
};
export default PopoverClose;
